const API_URL = process.env.REACT_APP_API_URL || 'https://gramaticaquest.online/api';

const authHeader = (token) => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${token}`
});

// Registro de nova conta
export async function apiRegister(nome, email, senha) {
  const res = await fetch(`${API_URL}/auth/register.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ nome, email, senha })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao criar conta');
  return data;
}

// Login
export async function apiLogin(email, senha) {
  const res = await fetch(`${API_URL}/auth/login.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, senha })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao fazer login');
  return data;
}

// Listar personagens da conta
export async function apiListProfiles(token) {
  const res = await fetch(`${API_URL}/profile/list.php`, {
    headers: authHeader(token)
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao listar personagens');
  return data;
}

// Criar novo personagem
export async function apiCreateProfile(token, name) {
  const res = await fetch(`${API_URL}/profile/create.php`, {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ name })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao criar personagem');
  return data;
}

// Deletar personagem
export async function apiDeleteProfile(token, profileId) {
  const res = await fetch(`${API_URL}/profile/delete.php?id=${profileId}`, {
    method: 'DELETE',
    headers: authHeader(token)
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao deletar personagem');
  return data;
}

// Carregar personagem específico (ao reabrir o app com token + profileId salvos)
export async function apiGetProfile(token, profileId) {
  const res = await fetch(`${API_URL}/profile/get.php?profile_id=${profileId}`, {
    headers: authHeader(token)
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao carregar personagem');
  return data;
}

// Salvar progresso (auto-save)
export async function apiSaveProfile(token, profileId, gameData) {
  const res = await fetch(`${API_URL}/profile/save.php`, {
    method: 'PUT',
    headers: authHeader(token),
    body: JSON.stringify({
      profileId,
      xp: gameData.xp,
      level: gameData.level,
      badges: gameData.badges,
      completedChapters: gameData.completedChapters,
      stats: gameData.stats
    })
  });
  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.error || 'Erro ao salvar progresso');
  }
}

// Salvar histórico de batalha
export async function apiBattleSave(token, profileId, { phaseId, isBoss, resultado, xpGained, wrongTopics }) {
  const res = await fetch(`${API_URL}/battle/save.php`, {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ profileId, phaseId, isBoss, resultado, xpGained, wrongTopics })
  });
  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.error || 'Erro ao salvar batalha');
  }
}
